<template>
  <div class="teacher-team-box">
    <div class="show-flex-box-c">
      <dl class="show-flex-box-c">
        <dt class="show-flex-box-c">
          <span>教研团队</span>
          <strong></strong>
        </dt>
        <dd class="choose-answer show-flex-box-c">
          <strong>德阳经开区社会事业局以德阳经开区科学教育研究培训中心为抓手，联合清华、北大、北科、北师大、陕师大、中国教科院、四川省教科院等国内顶级科研单位专家，成立德阳经开区科学教育技术委员会，组建课程研发、教学教研，教师共享，评价与大数等教研团队，为学校提供教育教学支撑。</strong>
        </dd>
        <dd class="mars-box-teachers slide-box">
          <div class="teachers-slide-box show-flex-box-r">
            <div class="slide-left show-flex-box-r"><strong class="teacher-prevs"></strong></div>
            <div class="teachers-slide teachers-swiper">
              <ul class="swiper-wrapper swiper-no-swiping">
                <li class="swiper-slide" v-for= "(item,index) in teacherList" :key= "index">
                  <dl>
                    <dt class="show-flex-box-r">
                      <span><img :src="item.image.o" alt="德阳经开科创" draggable="false"></span>
                    </dt>
                    <dd class="show-flex-box-c">
                      <h3>{{item.name}}</h3>
                      <strong>{{item.level}}</strong>
                      <p><strong class="scroll-content">{{item.summary}}</strong></p>
                    </dd>
                  </dl>
                </li>
              </ul>
              <div class="swiper-pagination swiper-teacher-pagination"></div>
            </div>
            <div class="slide-right show-flex-box-r"><strong class="teacher-nexts"></strong></div>
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import "@/../static/css/swiper-4.4.1.min.css"
import Swiper from '@/../static/js/swiper-4.4.1.min.js'

export default {
  name: 'teacher_team_cpn',
  data () {
    return {
      teacherList: false
    }
  },
  created() {
    this.getHomeTeachers();
  },
  updated() {
    this.initTeacherSwiper();
  },
  methods: {
    // 滚动初始化
    initScroll: function() {

    },
    getHomeTeachers: function() {
      this.$client.getHomeTeachers()
      .then((res) => {
        this.teacherList = res.data.list;
      }).catch((err) =>{

      })
    },
    initTeacherSwiper: function() {
        var marsSwiper = new Swiper('.teachers-swiper', {
        speed: 500,
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween : 30,
        noSwiping: true,
        pagination: {
          el: '.swiper-teacher-pagination'
        },
        navigation: {
          nextEl: '.teacher-nexts',
          prevEl: '.teacher-prevs',
        },
      });
      this.initScroll();
    },
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .choose-mars-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .teacher-team-box{
    width: 100%;
    background: #fafafa;
    &>div{
      margin: 0 auto;
      width: 1200px;
      align-items: center;
      &>dl{
        width: 100%;
        align-items: center;
        &>dt{
          align-items: center;
          &>span{
            word-wrap: none;
            .choose-mars-font-style( 40px; bold; auto; #191D21 );
            padding-top: 100px;
          }
          &>strong{
            display: block;
            width: 130px;
            height: 5px;
            background: #FF7800;
            margin-top: 19px;
            margin-bottom: 38px;
          }
        }
        &>.choose-answer{
          align-items: center;
          padding-bottom: 90px;
          &>strong{
            .choose-mars-font-style( 18px; 400; 34px; #3E3A39 );
          }
        }
        &>.slide-box {
        height: 440px;
        padding-bottom: 80px;
        .teachers-slide-box {
          width: 1200px;
          height: 100%;
          margin: 0 auto;
          .slide-left, .slide-right{
            width: 48px;
            height: 100%;
            cursor: pointer;
          }
          .slide-left strong, .slide-right strong {
            flex-grow: 1;
            flex-shrink: 0;
            background-repeat: no-repeat;
            background-size: 18px 30px;
          }
          .slide-left strong {
            background-position: center left;
            background-image: url("../../assets/common/marsbox_hover_left.png");
          }
         .slide-right strong {
            background-position: center right;
            background-image: url("../../assets/common/marsbox_hover_right.png");
          }
          .teachers-slide {
            position: relative;
            overflow: hidden;
            width: 1200px;
            padding-bottom: 38px;
            &>ul {
              &>li {
                width: 280px;
                background: #fff;
                &>dl {
                  overflow: hidden;
                  width: 100%;
                  height: 410px;
                  &>dt {
                    overflow: hidden;
                    width: 100%;
                    height: 130px;
                    padding-left: 12%;
                    padding-right: 12%;
                    border-bottom-left-radius: 50%;
                    border-bottom-right-radius: 50%;
                    margin-left: -12%;
                    justify-content: center;
                    align-items: flex-end;
                    background: #F5F5F5;
                    span {
                      overflow: hidden;
                      display: flex;
                      width: 280px;
                      height: 130px;
                      img {
                        display: block;
                        width: auto;
                        height: 130px;
                        flex-grow: 1;
                        object-fit: cover;
                      }
                    }
                  }
                  &>dd {
                    overflow: hidden;
                    margin-top: 27px;
                    &>h3,&>strong {
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }
                    &>h3 {
                      text-align: center;
                      font-size: 18px;
                      font-weight: bold;
                      margin-bottom: 12px;
                      color: #2D2D2D;
                    }
                    &>strong {
                      display: block;
                      text-align: center;
                      font-size: 16px;
                      font-weight: 500;
                      line-height: 17px;
                      margin-bottom: 22px;
                      color: #585C64;
                    }
                    p {
                      overflow: hidden;
                      width: 227px;
                      height: 159px;
                      margin: 0 auto;
                      &>strong {
                        display: block;
                        overflow-y:scroll;
                        overflow-x: hidden;
                        height: 100%;
                        font-size: 14px;
                        line-height: 22px;
                        font-weight: 500;
                        word-break: normal;
                        white-space: pre-wrap;
                        white-space: pre-line;
                        word-wrap: break-word;
                        text-align: justify;
                        color: #585C64;
                      }
                    }
                  }
                }
              }
            }
            &>.swiper-pagination {
              bottom: 0;
            }
          }
        }
      }
      }
    }
  }
</style>
<style>
.mars-box-teachers {
  position: relative;
  padding-bottom: 32px;
}
.mars-box-teachers .swiper-pagination {
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
  bottom: 0;
}
.mars-box-teachers .swiper-pagination span {
  display: block;
  width: 50px;
  height: 2px;
  border-radius: 0;
  margin-right: 10px;
  background: #fff;
}
.mars-box-teachers .swiper-pagination span:last-child {
  margin-right: 0;
}
.mars-box-teachers .swiper-pagination span.swiper-pagination-bullet-active {
  background: #ff7800;
}
</style>



// WEBPACK FOOTER //
// src/components/home/teacher_team_cpn.vue